import { SidePanel } from 'fm.bx.sidepanel';

export class SidePanels
{
	constructor()
	{
		if (SidePanels.instance) {
            return SidePanels.instance;
        }

		SidePanels.instance = this;

        return this;
	}

	static getInstance()
	{
		return new SidePanels();
	}

	openOrgSidePanel(url, data, onSave, onClose)
	{
		const sidepanel = new FM.BX.SidePanel(url, {
			width: 700,
			allowChangeHistory: false,
			allowChangeTitle: false, 
			requestParams: {
				title: data.title
			}
		})

		let wasSave = false;

		sidepanel.onMessage('contact-edit:save', function(result) {
			// console.log(111111111111111111111);
			wasSave = result.success;
			if (typeof onSave === 'function') {
				onSave(result, sidepanel);
			}
		})

		sidepanel.on('close', function(result) {
			// console.log(9999999999999999999999999);
			result.wasSave = wasSave;
			if (typeof onClose === 'function') {
				onClose(result, sidepanel);
			}
		})

		// let redirectUrl = null;
		// let wasSave = null;

		// sidepanel.onMessage('persons.detail.edit:save', function(eventData) {
			
		// 	wasSave = true;
		// 	redirectUrl = eventData['redirectUrl'];
		// 	sidepanel.close();
		// })

		// sidepanel.on('closeComplete', function() {
		// 	if (wasSave) {
		// 		window.location.href = redirectUrl;
		// 	}
		// })

		sidepanel.open();

		return sidepanel;
	}
}
